<template>
  <div></div>
</template>
<script>
import { getStoreBySlug } from "../../api/services/storeService.js";

export default {
  name: "SlugCheck",
  props: {
    slug: {
      type: String,
      default: "",
    },
  },
  created() {
    let that = this;

    getStoreBySlug(this.slug)
      .get()
      .then(function (snapshot) {
        if (snapshot.docs.length == 0) {
          that.$router.push({ name: "notFoundPage" });
        } else {
          let store = snapshot.docs[0].data();

          const storeRoute = that.$router.resolve({
            name: "store",
            params: { storename: store.ID },
            replace: true,
          });
          window.location = storeRoute.href;
        }
      });
  },
};
</script>
